import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cancel",
  "use": "icon-cancel-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cancel\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,11.06l1.89-1.89.94.94L12.94,12l1.89,1.89-.94.94L12,12.94l-1.89,1.89-.94-.94L11.06,12,9.17,10.11l.94-.94ZM12,17a5,5,0,1,0-5-5A5,5,0,0,0,12,17Zm0,1.67A6.67,6.67,0,1,1,18.67,12,6.67,6.67,0,0,1,12,18.67Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol